import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import common translations
import commonFr from '@/locales/common/fr.json';
// Import locale files from different screens
import emailVerificationResultFr from '@/screens/email-verification-result/locales/fr.json';
import loginIdFr from '@/screens/login-id/locales/fr.json';
import loginPasswordFr from '@/screens/login-password/locales/fr.json';
import mfaBeginEnrollOptionsFr from '@/screens/mfa-begin-enroll-options/locales/fr.json';
import mfaCountryCodesFr from '@/screens/mfa-country-codes/locales/fr.json';
import mfaEmailChallengeFr from '@/screens/mfa-email-challenge/locales/fr.json';
import mfaEnrollResultFr from '@/screens/mfa-enroll-result/locales/fr.json';
import mfaLoginOptionsFr from '@/screens/mfa-login-options/locales/fr.json';
import mfaSmsChallengeFr from '@/screens/mfa-sms-challenge/locales/fr.json';
import mfaSmsEnrollmentFr from '@/screens/mfa-sms-enrollment/locales/fr.json';
import mfaSmsListFr from '@/screens/mfa-sms-list/locales/fr.json';
import passkeyEnrollmentFr from '@/screens/passkey-enrollment/locales/fr.json';
import resetPasswordFr from '@/screens/reset-password/locales/fr.json';
import resetPasswordEmailFr from '@/screens/reset-password-email/locales/fr.json';
import resetPasswordErrorFr from '@/screens/reset-password-error/locales/fr.json';
import resetPasswordRequestFr from '@/screens/reset-password-request/locales/fr.json';
import resetPasswordSuccessFr from '@/screens/reset-password-success/locales/fr.json';
import signupIdFr from '@/screens/signup-id/locales/fr.json';
import signupPasswordFr from '@/screens/signup-password/locales/fr.json';

const resources = {
  fr: {
    common: commonFr,
    emailVerificationResult: emailVerificationResultFr,
    loginId: loginIdFr,
    loginPassword: loginPasswordFr,
    mfaBeginEnrollOptions: mfaBeginEnrollOptionsFr,
    mfaCountryCodes: mfaCountryCodesFr,
    mfaEmailChallenge: mfaEmailChallengeFr,
    mfaEnrollResult: mfaEnrollResultFr,
    mfaLoginOptions: mfaLoginOptionsFr,
    mfaSmsChallenge: mfaSmsChallengeFr,
    mfaSmsEnrollment: mfaSmsEnrollmentFr,
    mfaSmsList: mfaSmsListFr,
    passkeyEnrollment: passkeyEnrollmentFr,
    resetPassword: resetPasswordFr,
    resetPasswordEmail: resetPasswordEmailFr,
    resetPasswordError: resetPasswordErrorFr,
    resetPasswordRequest: resetPasswordRequestFr,
    resetPasswordSuccess: resetPasswordSuccessFr,
    signupId: signupIdFr,
    signupPassword: signupPasswordFr,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false, // React already safeguards against XSS
  },
});

export default i18n;
